var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Refresh_svg__a)",
    fill: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.325 5.11 1.66.8.16-.12a7.142 7.142 0 0 1 5.72-2.88c3.26 0 6.1 2.21 6.9 5.38l-1.35.52c-.56-2.54-2.92-4.45-5.53-4.45-1.67 0-3.25.73-4.32 2.01l-.18.21 1.8.87-3.78 1.61-1.08-3.95ZM9.865 17.09c-3.41 0-6.35-2.44-6.99-5.81l1.38-.54a5.64 5.64 0 0 0 5.59 4.88c1.88 0 3.63-.93 4.69-2.49l.14-.21-1.84-.88 3.77-1.61 1.06 3.95-1.63-.79-.16.14a7.032 7.032 0 0 1-6.02 3.35l.01.01Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Refresh_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2.325 2.91)",
    d: "M0 0h15.35v14.18H0z"
  })))));
};
export default SvgRefresh;